import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarHeaderLevelFn = /* @__PURE__ */ createRecipe('calendar-header-level', {}, [])

const calendarHeaderLevelVariantMap = {}

const calendarHeaderLevelVariantKeys = Object.keys(calendarHeaderLevelVariantMap)

export const calendarHeaderLevel = /* @__PURE__ */ Object.assign(memo(calendarHeaderLevelFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarHeaderLevel',
  __getCompoundVariantCss__: calendarHeaderLevelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarHeaderLevelVariantKeys,
  variantMap: calendarHeaderLevelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarHeaderLevelVariantKeys)
  },
  getVariantProps: calendarHeaderLevelFn.getVariantProps,
})